import { render, staticRenderFns } from "./NotificationWalletShareRevoke.vue?vue&type=template&id=55ea6e78&scoped=true"
import script from "./NotificationWalletShareRevoke.vue?vue&type=script&lang=js"
export * from "./NotificationWalletShareRevoke.vue?vue&type=script&lang=js"
import style0 from "./NotificationWalletShareRevoke.vue?vue&type=style&index=0&id=55ea6e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea6e78",
  null
  
)

export default component.exports